import React from "react";

function n(value) {
  const num = Number(value);
  return Number.isFinite(num) ? num : 0;
}

function getTransform(node) {
  return {
    position: {
      x: node?.transform?.position?.x ?? 0,
      y: node?.transform?.position?.y ?? 0,
      z: node?.transform?.position?.z ?? 0,
    },
    rotation: {
      x: node?.transform?.rotation?.x ?? 0,
      y: node?.transform?.rotation?.y ?? 0,
      z: node?.transform?.rotation?.z ?? 0,
    },
  };
}

export default function LayoutSimplePanel({
  selectedNode,
  resolvedNode,
  onChangeNode,
}) {
  const node = selectedNode || resolvedNode;

  if (!node) {
    return null;
  }

  const transform = getTransform(node);

  function updateTransform(nextTransform) {
    onChangeNode?.({
      id: node.id,
      transform: nextTransform,
    });
  }

  function updatePosition(axis, value) {
    updateTransform({
      ...transform,
      position: {
        ...transform.position,
        [axis]: value === "" ? "" : Number(value),
      },
    });
  }

  function move(dx, dz) {
    updateTransform({
      ...transform,
      position: {
        ...transform.position,
        x: n(transform.position.x) + dx,
        z: n(transform.position.z) + dz,
      },
    });
  }

  function rotateY(delta) {
    updateTransform({
      ...transform,
      rotation: {
        ...transform.rotation,
        y: n(transform.rotation.y) + delta,
      },
    });
  }

  return (
    <div className="border rounded p-3 bg-white space-y-3">
      <div>
        <div className="font-semibold text-sm">Layout / position</div>
        <div className="text-xs text-slate-500">
          Jednostavno slaganje elemenata u prostoru.
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2">
        <div>
          <label className="text-xs text-slate-500">Position X</label>
          <input
            type="number"
            value={transform.position.x}
            onChange={(e) => updatePosition("x", e.target.value)}
            className="w-full px-2 py-1 border rounded text-sm"
          />
        </div>

        <div>
          <label className="text-xs text-slate-500">Position Z</label>
          <input
            type="number"
            value={transform.position.z}
            onChange={(e) => updatePosition("z", e.target.value)}
            className="w-full px-2 py-1 border rounded text-sm"
          />
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2">
        <button
          type="button"
          onClick={() => move(-100, 0)}
          className="px-2 py-2 border rounded bg-slate-50 text-sm"
        >
          ← Left
        </button>

        <button
          type="button"
          onClick={() => move(0, -100)}
          className="px-2 py-2 border rounded bg-slate-50 text-sm"
        >
          ↑ Back
        </button>

        <button
          type="button"
          onClick={() => move(100, 0)}
          className="px-2 py-2 border rounded bg-slate-50 text-sm"
        >
          Right →
        </button>

        <button
          type="button"
          onClick={() => move(0, 100)}
          className="px-2 py-2 border rounded bg-slate-50 text-sm col-span-3"
        >
          ↓ Front
        </button>
      </div>

      <div className="grid grid-cols-2 gap-2">
        <button
          type="button"
          onClick={() => rotateY(-90)}
          className="px-3 py-2 border rounded bg-slate-50 text-sm"
        >
          Rotate -90°
        </button>

        <button
          type="button"
          onClick={() => rotateY(90)}
          className="px-3 py-2 border rounded bg-slate-50 text-sm"
        >
          Rotate +90°
        </button>
      </div>
    </div>
  );
}